import { Store } from '../../types'

export const industriesSelector = (store: Store) => store.entities.industries || []
